import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021138?utm_source=public_profile&utm_campaign=acharya_ji_ajay_l_agrawal';
const WHATSAPP_URL = 'https://wa.me/919960067177';
const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/950656ff8acc2b4c64dfb2a5e756971f95d9a65d0f8c5ef3b6e107600fb8dee58cb5b46485e4f90e0b9e2ba9c3364607/images/aW1hZ2UvcG5n/eb4bceeb288390e78457973c0c9f34e6.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-brand-dark/95 backdrop-blur-md shadow-lg border-b border-brand-gold/20' : 'bg-brand-dark'}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Acharya Ajay L Agarwal" className="h-20 md:h-24 w-auto object-contain" />
        </div>
        <div className="hidden md:flex items-center gap-6">
          <button
            onClick={() => scrollTo('about')}
            className="text-brand-light/80 hover:text-brand-gold transition-colors duration-300 font-medium text-base tracking-wide"
          >
            About
          </button>
          <button
            onClick={() => scrollTo('consult')}
            className="text-brand-light/80 hover:text-brand-gold transition-colors duration-300 font-medium text-base tracking-wide"
          >
            Consultation
          </button>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-3 border border-brand-gold/40 text-brand-gold hover:bg-brand-gold hover:text-brand-dark transition-all duration-300 rounded-sm font-bold text-sm tracking-wide"
          >
            <FiMessageCircle className="text-base" />
            Click to WhatsApp
          </a>
          <a
            href={TOPMATE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3 bg-brand-gold text-brand-dark text-base font-bold rounded-sm hover:bg-brand-goldDark hover:text-white transition-all duration-400 tracking-wide shadow-md"
          >
            Book Consultation
          </a>
        </div>
        {/* Mobile WhatsApp button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex md:hidden items-center gap-2 px-4 py-2.5 border border-brand-gold/40 text-brand-gold hover:bg-brand-gold hover:text-brand-dark transition-all duration-300 rounded-sm font-bold text-sm"
        >
          <FiMessageCircle className="text-base" />
          <span className="text-xs">WhatsApp</span>
        </a>
      </div>
    </motion.nav>
  );
}